<script lang="ts">
  import '../../../../node_modules/bootstrap/js/dist/collapse';
  import { getAbsoluteUrl } from '../../../common/util';
  import ContentCard from './ContentCard.svelte';
  export let data: any;
</script>

<ContentCard title={data.title} collpasableId={data.title.substr(0, 3).replace(/\s/g, '')}>
  <nav class="nav flex-column mb-5">
    {#each data?.components as item}
      {#if item?.linkName}
        <a class="nav-link" target={item?.target === 'true' ? '_blank' : ''} href={getAbsoluteUrl(item?.url)}
          >{item?.linkName}
        </a>
      {/if}
    {/each}
  </nav>
</ContentCard>

<style lang="scss">
  @import '../../../common/styles/vars.scss';
  .nav-link {
    color: $color-white;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    padding: 0 0 11px 0;
  }
</style>
